import React from 'react';
import { Form, ButtonGroup, Dropdown, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faAngleDown } from '@fortawesome/free-solid-svg-icons';

const DropdownDisplayList = React.memo((props) => {
    const selectedOption = props.options?.find(opt => opt[props.valueField] === props.formHandler.values[props.name] );
    const displayClass = props.formHandler.touched[props.name] && props.formHandler.errors[props.name] ? "custom-form-control-error is-invalid" : "";
    return (
        <>
            <Form.Label className="dropdown-group-label">{props.label}</Form.Label>
            <span className={displayClass}>
            <Dropdown menuAlign={props.menuAlign ? props.menuAlign : "left"}
                className="custom-form-control"
                as={ButtonGroup}
                name={props.name}
                onBlur={props.formHandler.handleBlur}
                >
                <div className="custom-form-control-primary-button">
                {
                    props.customButton ? props.customButton : 
                        <Button block className={"text-left lh-1 pb-2 "} style={{ "fontSize": "small" }} variant={"outline-" + props.variant}>
                            {props.displaySelected && props.displaySelected(selectedOption)}
                        </Button>
                }            
                </div>
                <Dropdown.Toggle split  className={props.options ? "noCaret" : "d-none noCaret"} variant={props.variant}><FontAwesomeIcon icon={faAngleDown} /></Dropdown.Toggle>
                {
                    props.addElement && <Button className="dropdown-button-custom dropdown-button-split-left" onClick={props.addElement} variant={props.variant}><FontAwesomeIcon icon={faPlus} /></Button>
                }
                <Dropdown.Menu className={props.options??"d-none "}>
                    {
                        props.options?.map((opt, idx) => (
                            <Dropdown.Item 
                                key={idx}
                                eventKey={opt.id} 
                                value={opt[props.valueField]} 
                                onClick={v => {props.formHandler.setFieldValue(props.name, opt[props.valueField], true)}}>
                                {props.displayOption ? props.displayOption(opt) : "Undefined option display"}
                            </Dropdown.Item>
                        ))
                    }
                </Dropdown.Menu>
                </Dropdown>      
            </span>
            <Form.Control.Feedback type="invalid">{props.formHandler.errors[props.name]}</Form.Control.Feedback>
        </>
    );
})

export default DropdownDisplayList;